const persisActionTypes = {
  PERSIST_UPDATE: 'persist/update',
} as const;

export {
  persisActionTypes,
};
